// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__kyH2L","header":"PatientBlock_header__1BY-9","label":"PatientBlock_label__1N49d","option":"PatientBlock_option__37DG-"};